/**
	@class: TypingListener
	
	@param {HTMLInputElement|HTMLTextAreaElement} target
	@param {Number} [timeout=500] ms
	@param {TypingListener~callback} [callback]
*/

export default class TypingListener {
	
	constructor(target, ...options) {
		
		if (!target)
			throw new Error("TypingListener: target is required");
		
		this.target = target;
		this.timeout = TypingListener.DEFAULT_TIMEOUT;
		this.callback = function(value){};
		
		for (let option of options) {
			if (option.constructor === Number)
				this.timeout = option;
			else if (option.constructor === Function)
				this.callback = option;
		}
		
		this.listener = this.target.addEventListener('keyup', function(evt) {
			if (this.typingTimeout) clearTimeout(this.typingTimeout);
			this.typingTimeout = setTimeout(function(){
				this.callback(this.target.value);
			}.bind(this), this.timeout);
		}.bind(this));
	}
	
	abort() {
		if (this.listener) {
			this.target.removeEventListener('keyup', this.listener);
			delete this.listener;
		}
	}
	
}

TypingListener.DEFAULT_TIMEOUT = 500;

/**
	@callback TypingListener~callback
	
	@param {String} value
*/


// WEBPACK FOOTER //
// ./~/vwa/TypingListener.js